<div class="pl">
  <header class="pl-cab">
    <div class="pl-cab__textos">
      <h4 class="page-title" *ngIf="exibirTitulo">Promoções</h4>
      <p>Descontos que entram sozinhos no carrinho quando o pedido cumpre as regras.</p>
    </div>
    <button type="button" class="pl-btn pl-btn--primario" (click)="criarPromocao()">
      <i class="fe-plus"></i> Nova promoção
    </button>
  </header>

  <div class="pl-lista" *ngIf="carregando && !promocoes.length">
    <div class="pl-esqueleto" *ngFor="let i of [1, 2, 3]"></div>
  </div>

  <div class="pl-vazio" *ngIf="!carregando && !promocoes.length">
    <span class="pl-vazio__icone"><i class="fe-tag"></i></span>
    <strong>Nenhuma promoção ainda</strong>
    <p>Crie descontos por produto, no segundo item, no pedido todo ou brindes que entram no carrinho sozinhos.</p>
    <button type="button" class="pl-btn pl-btn--primario" (click)="criarPromocao()">
      <i class="fe-plus"></i> Criar primeira promoção
    </button>
  </div>

  <div class="pl-lista" *ngIf="promocoes.length">
    <article class="pl-card" *ngFor="let promocao of promocoes"
             [ngClass]="'pl-card--' + statusDa(promocao).id"
             (click)="editarPromocao(promocao)">
      <span class="pl-card__icone"><i class="fe-tag"></i></span>

      <div class="pl-card__principal">
        <div class="pl-card__topo">
          <strong class="pl-card__nome">{{promocao.descricao}}</strong>
          <span class="pl-status" [ngClass]="'pl-status--' + statusDa(promocao).id">
            <span class="pl-status__ponto"></span>{{statusDa(promocao).rotulo}}
          </span>
        </div>

        <div class="pl-card__meta">
          <span *ngIf="promocao.dataInicio || promocao.dataFim">
            <i class="fe-calendar"></i>
            {{promocao.dataInicio ? (promocao.dataInicio | date: "dd/MM/yyyy") : 'Sem início'}}
            <i class="fe-arrow-right pl-seta"></i>
            {{promocao.dataFim ? (promocao.dataFim | date: "dd/MM/yyyy") : 'Sem fim'}}
          </span>
          <span><i class="fe-clock"></i> {{diasDa(promocao)}}</span>
          <span *ngIf="promocao.cumulativa"><i class="fe-layers"></i> Cumulativa</span>
          <span class="pl-id">#{{promocao.id}}</span>
        </div>

        <div class="pl-regras" *ngIf="promocao.regras?.length">
          <span class="pl-regra" *ngFor="let regra of primeirasRegras(promocao)" [class.pl-regra--inativa]="!regra.ativa">
            <i [ngClass]="iconeDaRegra(regra)"></i> {{descrevaRegra(regra)}}
          </span>
          <span class="pl-regra pl-regra--mais" *ngIf="promocao.regras.length > 2">+{{promocao.regras.length - 2}}</span>
        </div>
      </div>

      <div class="pl-card__acoes" (click)="$event.stopPropagation()">
        <label class="pl-switch" [title]="promocao.ativa ? 'Pausar promoção' : 'Ativar promoção'">
          <input type="checkbox" role="switch" [checked]="promocao.ativa" [disabled]="promocao.processando"
                 (change)="alterneAtiva(promocao)" [attr.aria-label]="promocao.ativa ? 'Pausar promoção' : 'Ativar promoção'">
          <span class="pl-switch__trilho"></span>
        </label>
        <button type="button" class="pl-icone-btn" (click)="editarPromocao(promocao)" title="Editar" aria-label="Editar promoção">
          <i class="fe-edit-2"></i>
        </button>
        <button type="button" class="pl-icone-btn pl-icone-btn--perigo" (click)="abraDialogRemover(promocao)"
                title="Remover" aria-label="Remover promoção">
          <i class="fe-trash-2"></i>
        </button>
      </div>
    </article>
  </div>
</div>

<kendo-dialog class="pl-dialogo" *ngIf="modalDeletar" (close)="close('cancel')" [minWidth]="250" [width]="420">
  <div class="pl-remover">
    <span class="pl-remover__icone"><i class="fe-trash-2"></i></span>
    <h3>Remover promoção?</h3>
    <p>"<strong>{{promocaoApagar.descricao}}</strong>" sai da lista. Para só suspender, use a chave ao lado.</p>
    <div class="pl-remover__acoes">
      <button type="button" class="pl-btn pl-btn--fantasma" (click)="canceleRemocao()">Cancelar</button>
      <button type="button" class="pl-btn pl-btn--perigo" (click)="confirmeRemocao()">Remover</button>
    </div>
  </div>
</kendo-dialog>
